export default __webpack_public_path__ + "static/media/Jessie.460d13b0.png";